export const gitCommit = '2982202e'
